async function request<T>(
    url: string,
    method: 'GET' | 'POST' = 'GET',
    body: object | null = null,
    params: Record<string, string> = {}
): Promise<T> {
    const searchParams = new URLSearchParams(params).toString();

    if (method === 'GET' && searchParams) {
        url += `?${searchParams}`;
    }

    const options: RequestInit = {
        method,
        headers: {
            'Content-Type': 'application/json',
        },
    };

    if (method === 'POST' && body) {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorDetails: {
            status: number;
            statusText: string;
            message: string;
            body: unknown;
        } = {
            status: response.status,
            statusText: response.statusText,
            message: `HTTP error! status: ${response.status} ${response.statusText}`,
            body: null,
        };

        try {
            //INFO: parsed as JSON
            const responseBody = await response.json();
            errorDetails.body = responseBody;
            if (typeof responseBody === 'object' && responseBody !== null) {
                if ('message' in responseBody && typeof responseBody.message === 'string') {
                    errorDetails.message = responseBody.message;
                } else if ('error' in responseBody && typeof responseBody.error === 'string') {
                    errorDetails.message = responseBody.error;
                }
            } else if (typeof responseBody === 'string' && responseBody.length > 0) {
                errorDetails.message = responseBody;
            }
        } catch (e) {
            //INFO: If it could not be parsed as JSON (e.g. empty body or not JSON), we try as text
            try {
                errorDetails.body = await response.text();
            } catch (e2) {
                //INFO: nothing to do if it can't be read as text either */
            }
        }

        const error = new Error(errorDetails.message);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (error as any).details = errorDetails;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (error as any).status = errorDetails.status;
        throw error;
    }

    return await response.json();
}

const get = <T>(url: string, params?: Record<string, string>) =>
    request<T>(url, 'GET', null, params);
const post = <T>(url: string, body: object, params?: Record<string, string>) =>
    request<T>(url, 'POST', body, params);

export { get, post };
